import CamerasView from 'features/cameras/components/cameras-view'
import UsersView from 'features/users/components/users-view'
import { TabPanel, TabView } from 'primereact/tabview'
import './settings-view.scss'

const SettingsView = () => {
  return (
    <div className='settings-container'>
      <TabView className='custom-tabview'>
        <TabPanel header='Câmeras'>
          <CamerasView></CamerasView>
        </TabPanel>
        <TabPanel header='Usuário'>
          <UsersView></UsersView>
        </TabPanel>
      </TabView>
    </div>
  )
}

export default SettingsView
